import { Input } from "@chakra-ui/input";
import { Box, Flex } from "@chakra-ui/layout";
import colors from "core/resources/theme/colors";
import { useEffect, useState } from "react";
import { AiOutlineSearch } from "react-icons/ai";

export interface InputSearchWhiteProps {
  onSearch: (q?: string) => void;
  defaultValue: string;
  placeholder?: string;
  maxW?: number | string;
}

function InputSearchWhite({
  onSearch,
  defaultValue,
  placeholder = "Procurar",
  maxW = 350,
}: InputSearchWhiteProps) {
  const [search, update] = useState<string>();

  useEffect(() => {
    update(defaultValue);
  }, [defaultValue]);

  const handleEnder = (ev: any) => {
    if (ev.keyCode === 13) {
      onSearch(search);
    }
  };

  return (
    <>
      <Box maxW={maxW} w="100%" d="flex" flexDir="row" pos="relative">
        <Flex
          pl={2}
          gridGap={2.5}
          alignItems="center"
          bg="white"
          borderWidth={1}
          borderColor={colors.inputBorderGray}
          rounded={8}
          w="100%"
        >
          <AiOutlineSearch color={colors.black700} fontSize={16} />
          <Input
            value={search}
            onChange={(v) => update(v.target.value)}
            placeholder={placeholder}
            onKeyDown={(ev) => handleEnder(ev)}
            roundedRight={8}
            roundedLeft={0}
            pl="8px"
            variant="outline"
            borderColor="transparent"
            borderWidth={0}
            backgroundColor="white !important"
            flex={1}
          />
        </Flex>
      </Box>
    </>
  );
}

export default InputSearchWhite;
